import { each, isArray } from "lodash";
import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 할일 목록

export const getTaskList = ({ ownership, approvalTargetStage, approvalTargetType, ...params }) => {
  if (ownership === 'owner' && approvalTargetStage === 'in_progress') {
    approvalTargetStage = 'approved';
  }
  return new Promise((resolve, reject) => {
    http
      // .post("/tasks/list", {
      .post(`/tasks/ownership/${ownership}/stage/${approvalTargetStage}/list`, {
        approvalTargetStage,
        ...approvalTargetType ? { approvalTargetType } : {},
        ...params
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 할일 상세
export const getTaskByPost = ({ approvalTargetIdx, postIdx, postType }) => {
  return new Promise((resolve, reject) => {
    http
      .post("/tasks/post", approvalTargetIdx ?
        { approvalTargetIdx } :
        {
          postIdx,
          postType
        })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTask = (taskIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post("/tasks/post", {
        taskIdx
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 결재승인
export const taskApproved = (approvalIdx, employeeSignIdx, comment) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/tasks/approvals/status/approved`, {
        taskIdxes: isArray(approvalIdx) ? approvalIdx : [approvalIdx],
        employeeSignIdx,
        comment

      })
      .then((res) => {

        each(res.data, data => {
          toast[data.result === 'failed' ? 'error' : 'success'](data.message);
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 위임하기
export const approvalsHandover = (params) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/tasks/approvals/handover`, params)
      .then((res) => {
        toast.success('결재 위임 요청에 성공했습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 결재반려
export const taskDenied = (approvalIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/tasks/approvals/status/denied`, {
        taskIdxes: isArray(approvalIdx) ? approvalIdx : [approvalIdx]
      })
      .then((res) => {
        toast.success('결재 반려되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 결재 취소
export const taskCancel = (taskIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .delete(`/tasks/approval-targets/${taskIdx}`)
      .then((res) => {
        toast.success('할일이 취소되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const approverTaskCancel = (taskIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .delete(`/tasks/approvals/${taskIdx}`)
      .then((res) => {
        toast.success('할일이 취소되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};